import "./buttons.scss";

/**
 * PrimaryButton component renders a button that triggers a click event.
 *
 * @param {Object} props - The properties object.
 * @param {boolean} [props.disabled=false] - Determines if the button is disabled.
 * @param {boolean} [props.visible=true] - Determines if the button is visible.
 * @param {string} [props.type=button] - Button type (eg may want a submit type).
 * @param {function} props.handleClick - The function to call when the button is clicked.
 * @param {ReactNode} props.children - The content to display inside the button.
 *
 * @returns {JSX.Element|null} The rendered button element or null if not visible.
 */
const PrimaryButton = ({
  disabled = false,
  visible = true,
  type = "button",
  handleClick,
  classes,
  children
}) => {
  if (!visible) {
    return null;
  }

  const buttonClass = classes ? `btn btn-primary ${classes}` : "btn btn-primary";

  return (
    <button className={buttonClass} disabled={disabled} onClick={handleClick} type={type}>
      {children}
    </button>
  );
};

export default PrimaryButton;
